import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import CheckLogin from '~/pages/CheckLogin';
import SignIn from '~/pages/SignIn';
import Home from '~/pages/Home';
import CommissionHistory from '~/pages/CommissionHistory';
import Trainings from '~/pages/Trainings/List';
import Training from '~/pages/Training';
import MaterialPromocional from '~/pages/MaterialPromocional';
import Crowdfunding from '~/pages/Crowdfunding';
import Referrals from '~/pages/Referrals';
import TeamView from '~/pages/Referrals/TeamView';
import Wallet from '~/pages/Wallet';
import UpdateWarning from '~/pages/UpdateWarning';
import Affiliates from '~/pages/Affiliates';
import CrowdfundingList from '~/pages/Affiliates/Crowdfunding/List';
import PromotionalMaterial from '~/pages/Affiliates/PromotionalMaterial';
import TrainingList from '~/pages/Affiliates/Training/List';

const En: React.FC = () => {
  return (
    <Switch>
      {/* <Route path={`${process.env.PUBLIC_URL}/`} component={UpdateWarning} /> */}
      <Route path={`${process.env.PUBLIC_URL}/en/`} exact component={SignIn} />
      <Route
        path={`${process.env.PUBLIC_URL}/en/dashboard`}
        component={Home}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/en/commission-history`}
        exact
        component={CommissionHistory}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/en/trainings`}
        exact
        component={Trainings}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/en/trainings/category/:slug`}
        exact
        component={Trainings}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/en/trainings/:slug`}
        exact
        component={Training}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/en/promotional-material`}
        exact
        component={MaterialPromocional}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/en/crowdfunding`}
        exact
        component={Crowdfunding}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/en/my-referrals`}
        exact
        component={Referrals}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/en/my-referrals/team-view/:slug`}
        exact
        component={TeamView}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/en/wallet/:slug`}
        exact
        component={Wallet}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/en/check-login/:token`}
        exact
        component={CheckLogin}
      />
    </Switch>
  );
};

export default En;
